import { CustomerTypeProviderContext } from '@tv2/lib-offspring/api/user/CustomerType';

import { useQuery } from '@tv2/lib-graphql';
import { useLoginStatus } from '@tv2/lib-offspring/api/user/UserProvider';
import { CustomerTypeDocument } from './__generated__/CustomerType';

export function CustomerTypeProvider({ children }: { children: React.ReactNode }) {
  const customerType = useCustomerType();
  return (
    <CustomerTypeProviderContext customerType={customerType}>
      {children}
    </CustomerTypeProviderContext>
  );
}

const fallbackState = {
  loading: false,
  hasActiveSubscription: false,
  subscriptionTracking: {},
  subscriptions: [],
  updateCardRelevant: false,
};

const useCustomerType = () => {
  const loginStatus = useLoginStatus();

  const response = useQuery({
    pause: loginStatus !== 'LOGGED_IN',
    query: CustomerTypeDocument,
    requestPolicy: 'cache-first',
  });

  if (response.error || loginStatus === 'NOT_LOGGED_IN') {
    return fallbackState;
  }

  if (response?.fetching || !response.data) return { ...fallbackState, loading: true };

  const { customerType } = response.data;

  if (!customerType) return fallbackState;

  const hasPlayAccess = customerType.products?.length > 0;

  const hasDTCSubscription = customerType.products?.some(sub => {
    return sub.providerType === 'DTC';
  });

  return {
    loading: false,
    hasActiveSubscription: hasPlayAccess,
    subscriptions: customerType.products,
    subscriptionTracking: customerType.subscriptionTracking || {},
    updateCardRelevant: hasDTCSubscription,
  };
};
